<div class="toast-container">
  <div class="toast" raUiToast [toastConfig]="toastConfig" (onButtonClick)="btnClick()"></div>
</div>
@if (displayMessage$ | async) {
  <ng-container></ng-container>
}
